import { Box, formatDate, getSpacing, Typography } from "@compass/core";
import { MatchDataProvider, useMatchData } from "../contexts";
import { DashboardTable } from "./DashboardTable";
import { DashboardCard } from "../components/DashboardCard";



const MatchTableCardContent = () => {
    const { tableRows, loading, reportDateFrom, reportDateTo } = useMatchData();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                <DashboardTable rows={tableRows} loading={loading} />
            </Box>
            <Box pt={getSpacing("lg")}>
                <Typography variant="caption">
                    Report dates: {formatDate(reportDateFrom)}
                    <> to </>
                    {formatDate(reportDateTo)}
                </Typography>
            </Box>
        </Box>
    );
};

export const MatchTableCard = () => {
    return (
        <MatchDataProvider>
            <DashboardCard title="Match Contribution">
                <MatchTableCardContent />
            </DashboardCard>
        </MatchDataProvider>
    );
};